"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _deleteCookie = _interopRequireDefault(require("./deleteCookie"));
var clearCredentials = {
  cognito: function cognito() {
    (0, _deleteCookie["default"])('cognitoIdToken');
  },
  microsoft: function microsoft() {
    (0, _deleteCookie["default"])('microsoftIdToken');
    (0, _deleteCookie["default"])('microsoftRefreshToken');
  },
  google: function google() {
    (0, _deleteCookie["default"])('googleIdToken');
    (0, _deleteCookie["default"])('googleRefreshToken');
  },
  all: function all() {
    clearCredentials.cognito();
    clearCredentials.microsoft();
    clearCredentials.google();
    (0, _deleteCookie["default"])('sessionId');
    (0, _deleteCookie["default"])('signInMode');
  }
};
module.exports = clearCredentials;